module.exports = __webpack_public_path__ + "static/media/Vetements2.97787718.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/designers/Vetements2.png
// module id = 151
// module chunks = 0